import React, { Component } from "react";
import "./popup.scss";

class Popup extends Component {
  render() {
    return (
      <div
        className={
          "Popup" +
          (this.props.active ? " active" : "") +
          (this.props.hidden ? " hidden" : "")
        }
        onClick={(e) => {
          if (
            !e.target.classList.contains("Popup") &&
            !e.target.classList.contains("CloseButton")
          )
            return;
          this.props.onClosePopup();
        }}
      >
        {this.props.children}
      </div>
    );
  }
}

export default Popup;
